








































import { defineComponent, reactive } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'
import userAggregateQuery from '@/lib/graphql/usersAggregate.query.gql'
import DashboardItem from '@/components/DashboardItem.vue'
import moment from 'moment'

interface ItemConfig {
  key: string
  colorBase: string
  title: string
  layout: string
  variables: {
    // eslint-disable-next-line
    where: any
  }
}

export default defineComponent({
  components: {
    DashboardItem
  },

  setup() {
    const yesterday = moment().startOf('day')
    const now = moment()

    const overallItemConfigs: ItemConfig[] = [
      {
        key: 'totalUsers',
        colorBase: 'blue',
        title: 'Total users',
        layout: 'col-span-1',
        variables: {
          where: null
        }
      },
      {
        key: 'totalPremiumUsers',
        colorBase: 'green',
        title: 'Total Premium users',
        layout: 'col-span-1',
        variables: {
          where: {
            // eslint-disable-next-line
            expires_at: {
              _gt: now
            }
          }
        }
      }
    ]

    const todayItemConfigs: ItemConfig[] = [
      {
        key: 'newUsers',
        colorBase: 'gray',
        title: 'New users today',
        layout: 'col-span-1',
        variables: {
          where: {
            // eslint-disable-next-line
            inserted_at: {
              _gt: yesterday
            }
          }
        }
      },
      {
        key: 'newPremium',
        colorBase: 'indigo',
        title: 'New premium today',
        layout: 'col-span-1',
        variables: {
          where: {
            _or: [
              {
                // eslint-disable-next-line
                ios_orders: {
                  status: { _eq: 'paid' },
                  // eslint-disable-next-line
                  inserted_at: { _gt: yesterday }
                }
              },
              {
                // eslint-disable-next-line
                android_orders: {
                  status: { _eq: 'paid' },
                  // eslint-disable-next-line
                  inserted_at: { _gt: yesterday }
                }
              },
              {
                // eslint-disable-next-line
                wechat_orders: {
                  status: { _eq: 'paid' },
                  // eslint-disable-next-line
                  inserted_at: { _gt: yesterday }
                }
              }
            ]
          }
        }
      },
      {
        key: 'expiredUsers',
        colorBase: 'orange',
        title: 'Expired premium today',
        layout: 'col-span-1',
        variables: {
          where: {
            // eslint-disable-next-line
            expires_at: {
              _gt: yesterday,
              _lte: now
            }
          }
        }
      }
    ]

    // eslint-disable-next-line
    const getCount = (variables: any) => {
      const { result, loading, error } = useQuery(userAggregateQuery, variables)

      const count = useResult(
        result,
        0,
        data => data.users_aggregate.aggregate.count
      )
      return {
        loading,
        error,
        count
      }
    }

    const toItem = (config: ItemConfig) => {
      const { count, loading, error } = getCount(config.variables)
      const { count: iosCount } = getCount({
        ...config.variables,
        where: {
          ...config.variables.where,
          // eslint-disable-next-line
          devices: { device_type: { _eq: 'ios' } }
        }
      })
      const { count: androidCount } = getCount({
        ...config.variables,
        where: {
          ...config.variables.where,
          // eslint-disable-next-line
          devices: { device_type: { _eq: 'android' } }
        }
      })
      return reactive({
        ...config,
        loading,
        error,
        count,
        iosCount,
        androidCount
      })
    }

    const overallItems = overallItemConfigs.map(toItem)

    const todayItems = todayItemConfigs.map(toItem)

    return {
      overallItems,
      todayItems
    }
  }
})
